import { createSelector } from 'reselect';

import { bikeTypesSelector, countriesSelector } from './app';

const slice = ({ staticPage }) => staticPage;

export const staticPageSelector = createSelector(
  slice,
  bikeTypesSelector,
  ({ data }, bikeTypes) => {
    if (!data) {
      return data;
    }

    const related = (data.related || []).map((item) => ({
      ...item,
      bikeType: bikeTypes.find(({ id }) => id === item.searchBikeType)
    }));

    const bikeType = bikeTypes.find(({ id }) => id === data.searchBikeType);

    return {
      ...data,
      bikeType,
      related
    };
  }
);

export const staticPageErrorSelector = createSelector(
  slice,
  ({ error }) => error
);

export const staticPageFetchingSelector = createSelector(
  slice,
  ({ isFetching }) => isFetching
);

export const staticPageCitySelector = createSelector(
  staticPageSelector,
  (data) => data ? data.city : null
);

export const staticPageCountrySelector = createSelector(
  staticPageCitySelector,
  countriesSelector,
  (city, countries) => {
    if (!city || !countries) {
      return null;
    }

    for (let country of countries) {
      if (country.cities.some(({ id }) => id === city.id)) {
        return country;
      }
    }

    return null;
  }
);



// WEBPACK FOOTER //
// ./src/selectors/staticPage.js